/* ==========================================================================
   SIGNAL EXP — Board finder
   Used by: sections/board-finder.liquid

   The section prints one JSON blob per finder. Everything that can change in
   the store comes from there, live: products, variants, prices, stock, photos,
   flex, terrain ratings, rider level, men's/women's tags and each board's
   spec sheet page (sizes, widths, stance, rider weight ranges).
   What the store does not hold lives in the section's Board blocks: shape,
   how well the board suits each riding style, and the reading.
   ========================================================================== */
(function () {
  'use strict';
  if (window.SignalBoardFinder) return;

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function one(n) { return (Math.round(n * 10) / 10).toFixed(1); }

  /* ------------------------------------------------------------------------
     DATA: turn what the section printed into boards the matcher can use
     ------------------------------------------------------------------------ */

  /* "158 Wide", "158W" and "158UW" are the same size. */
  function sizeKey(t) {
    var m = /(\d{2,3}(?:\.\d+)?)\s*(.*)$/.exec(String(t || ''));
    return m ? m[1] + (/w/i.test(m[2]) ? 'W' : '') : '';
  }
  function nums(t) { return (String(t || '').match(/-?\d+(?:\.\d+)?/g) || []).map(Number); }

  /* Read a spec sheet page: the sizing table on every board's product page. */
  function parseSpec(html) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(String(html), 'text/html');
    var out = [];
    Array.prototype.forEach.call(doc.querySelectorAll('table'), function (table) {
      if (out.length) return;
      var rows = Array.prototype.map.call(table.querySelectorAll('tr'), function (tr) {
        return Array.prototype.map.call(tr.children, function (c) { return (c.textContent || '').replace(/\s+/g, ' ').trim(); });
      });
      var h = -1, col = {};
      rows.some(function (r, i) {
        if (!r.some(function (c) { return /size/i.test(c); })) return false;
        h = i;
        r.forEach(function (c, j) {
          if (/size/i.test(c) && col.size == null) col.size = j;
          else if (/waist|tip/i.test(c)) col.width = j;
          else if (/edge/i.test(c)) col.edge = j;
          else if (/stance/i.test(c)) col.stance = j;
          else if (/set\s*back/i.test(c)) col.setback = j;
          else if (/weight/i.test(c) && /lb/i.test(c)) col.lb = j;
          else if (/weight/i.test(c) && /kg/i.test(c)) col.kg = j;
        });
        return true;
      });
      if (h < 0 || col.size == null || col.width == null || (col.lb == null && col.kg == null)) return;
      rows.slice(h + 1).forEach(function (r) {
        var key = sizeKey(r[col.size]), w = nums(r[col.width]);
        var wt = col.lb != null ? nums(r[col.lb]).map(Math.abs) : nums(r[col.kg]).map(function (k) { return Math.abs(k) * 2.20462; });
        var wtText = col.lb != null ? r[col.lb] : r[col.kg];
        if (!key || w.length < 3 || wt.length < 2) return;
        out.push({
          label: key, len: parseFloat(key), wide: /W$/.test(key),
          tip: Math.abs(w[0]), waist: Math.abs(w[1]), tail: Math.abs(w[2]),
          stance: col.stance != null ? (nums(r[col.stance])[0] || 21) : 21,
          sb: col.setback != null ? Math.abs(nums(r[col.setback])[0] || 0) : 0,
          lo: wt[0], hi: wt[1], plus: /\+/.test(wtText || '')
        });
      });
    });
    return out.length ? out : null;
  }

  /* Safety net: the 2627 spec sheets as of October 2026, used only if a board's
     spec sheet page is missing or its table cannot be read.
     Row = [size, tip, waist, tail, stance in, setback in, lb low, lb high, open-ended] */
  var FALLBACK = {
    '2627-snowboards-park-series-spiral': [['138',26.4,22.5,26.4,18.1,0,75,105],['142',27.1,23.2,27.1,18.3,0,90,120],['146',27.9,23.8,27.9,19.3,0,100,130],['150',28.6,24.5,28.6,21.9,0,110,145],['152',29,25.1,29,22,0,115,150],['154',29.4,25.2,29.4,22.2,0,125,160],['156',29.8,25.5,29.8,22.4,0,130,170],['158',30.2,25.8,30.2,22.8,0,140,189]],
    '2627-snowboards-park-pro-chain-breaker': [['149',29.5,25.1,29.5,20,0,100,140],['151',29.9,25.4,29.9,21.3,0,110,150],['151W',30.5,26,30.5,21.3,0,120,160],['153',30.1,25.4,30.1,21.7,0,120,170],['153W',30.6,26,30.6,21.7,0,130,180],['155',30.4,25.7,30.4,22,0,130,190],['155W',30.9,26.2,30.9,22,0,140,200],['157W',31.1,26.3,31.1,22.8,0,150,210],['160W',31.1,26.6,31.1,22.8,0,160,230]],
    '2627-snowboards-compass-the-strangers': [['147',29.1,25.2,29.1,21.3,0,100,135],['153',29.5,25.5,29.5,22,0,120,165],['156',29.6,25.8,29.6,22,0,130,180]],
    '2627-snowboards-ambient-aurora': [['138',26.4,22.5,26.4,18.1,0,80,110],['140',26.8,22.9,26.8,18.1,0,90,120],['142',27.1,23.2,27.1,18.3,0,100,130],['144',27.5,23.5,27.5,18.9,0,110,140],['146',27.9,23.8,27.9,19.3,0,120,150],['150',28.6,24.5,28.6,21.9,0,130,170]],
    '2627-snowboards-disruptor-wavelength': [['148',28.4,24.5,28.4,19.9,0,115,145],['152',28.8,24.8,28.8,20.9,0,135,165],['154',29.2,25.1,29.2,20.9,0,140,175],['156',29.6,25.4,29.6,22,0,145,185],['156W',30.2,26.1,30.2,22,0,150,190],['158',30,25.8,30,22,0,155,200],['158W',31,26.8,31,22,0,160,210,1]],
    '2627-snowboards-ludo-nimbus': [['150',31,25.8,29,20.9,2.5,130,170],['154',31.6,26,29.6,21.3,2.5,140,190],['158',31.6,26.5,29.6,21.8,2.5,160,210],['162',31.6,26.7,29.6,22.4,2.5,180,240]],
    '2627-snowboards-yuki-pro': [['150',28.73,24.5,28.73,21,1,110,150],['154',28.8,25,28.8,21,1,125,165],['156',29.4,25.1,29.4,21,1.5,135,175],['156W',31.06,26.5,31.06,21,1.5,150,200,1],['158',29.4,25.4,29.4,22,1.5,145,190],['158W',31.5,27.2,31.5,22,1.5,160,215,1],['162W',30.8,26.7,30.8,22,1.5,170,230,1]],
    '2627-snowboards-yup-redline': [['153',30,25.1,28.7,21,4.6,130,170],['157',30.8,25.8,29.4,22,5.2,150,190],['161',31.6,26.4,30.2,23,5,170,220,1]],
    '2627-snowboards-park-kids-zoich': [['115',25.5,22.5,25.5,16.1,0,40,100],['125',26.4,23.2,26.4,17,0,50,105],['135',27.6,24,27.6,18.1,0,60,115]]
  };
  function fallbackSizes(handle) {
    var rows = FALLBACK[handle];
    return rows ? rows.map(function (r) {
      return { label: r[0], len: parseFloat(r[0]), wide: /W$/.test(r[0]), tip: r[1], waist: r[2], tail: r[3], stance: r[4], sb: r[5], lo: r[6], hi: r[7], plus: !!r[8] };
    }) : null;
  }

  function profileSay(title) {
    var t = String(title || '').toLowerCase();
    if (/3d/.test(t)) return 'Camber with a 3D base that lifts the edges for a catch-free feel.';
    if (/nose\s*(&|and)\s*tail/.test(t)) return 'Camber with lift at both ends for float and forgiveness.';
    if (/early rise|rocker/.test(t)) return 'Camber through the body with a lifted nose for float.';
    return 'A spring under your feet: pop, edge hold, stability at speed.';
  }
  function flexSay(f) {
    if (f <= 3) return 'Soft. Forgiving and easy to press.';
    if (f <= 5) return 'Soft-medium. Playful, with some backbone.';
    if (f <= 6) return 'Medium. Presses when asked, holds when pushed.';
    if (f <= 7) return 'Medium-stiff. Stable at speed, more pop, less forgiving.';
    return 'Stiff. Maximum drive and edge hold. Wants a strong rider.';
  }
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }

  function buildBoard(d) {
    var live = parseSpec(d.specHtml);
    var sizes = live || fallbackSizes(d.handle);
    if (!sizes) return null;
    var variants = {};
    (d.variants || []).forEach(function (v) { variants[sizeKey(v.title)] = v; });
    var matched = sizes.filter(function (s) { return variants[s.label]; });
    /* Only offer sizes the store sells. If nothing lines up, keep them all and link to the product page instead. */
    if (matched.length) sizes = matched;
    sizes.forEach(function (s) {
      var v = variants[s.label];
      s.variantId = v ? v.id : null; s.available = v ? !!v.available : true; s.price = v ? v.price : null;
    });
    var parts = String(d.title || '').split(/\s+[-–—]\s+/);
    var tags = (d.tags || []).map(function (t) { return String(t).toLowerCase(); });
    var m = tags.indexOf('category-mens') > -1, w = tags.indexOf('category-womens') > -1;
    var cats = d.kids || m === w ? 'mw' : m ? 'm' : 'w';
    var levels = d.levels; if (typeof levels === 'string') { try { levels = JSON.parse(levels); } catch (e) { levels = [levels]; } }
    var shape = d.shape === 'dir' || d.shape === 'dtwin' ? d.shape : 'twin';
    return {
      id: String(d.handle), handle: d.handle, name: parts[0] || d.title, sign: d.sign || parts.slice(1).join(' – ') || parts[0],
      url: d.url, image: d.image, price: d.price,
      who: d.kids ? 'Kids' : cats === 'mw' ? 'Unisex' : cats === 'm' ? 'Men’s' : 'Women’s', cats: cats,
      shape: shape, nose: shape === 'dir' ? 'point' : 'blunt',
      profile: d.profile || 'Camber', profileSay: profileSay(d.profile),
      flex: clamp(Math.round(num(d.flex, 5)), 0, 10),
      terr: { park: clamp(num(d.park, 5), 0, 10), all: clamp(num(d.all, 5), 0, 10), pow: clamp(num(d.pow, 5), 0, 10) },
      beginner: (levels || []).some(function (l) { return /beginner/i.test(l); }),
      kids: !!d.kids, wideByDesign: !!d.wide, channel: !!d.channel, womensPick: !!d.womensPick,
      setback: sizes[0].sb || 0,
      style: { feet: num(d.feet, 5) / 10, playful: num(d.playful, 5) / 10, surfy: num(d.surfy, 5) / 10, charging: num(d.charging, 5) / 10 },
      vibe: d.vibe || '', reading: d.reading || '', move: d.move || '', lucky: d.lucky || '', watch: d.watch || '',
      sizes: sizes, liveSpec: !!live
    };
  }

  /* ------------------------------------------------------------------------
     MATCHING
     ------------------------------------------------------------------------ */
  /* Boot size to foot length in cm (mondopoint). */
  function bootToMondo(system, size) {
    if (system === 'usw') return size + 17;
    if (system === 'eu') return 0.75 * size - 4.4;
    return size + 18;
  }
  /* Waist width (cm) a boot of this length sits well on. */
  function idealWaist(mondo) { return mondo <= 28 ? 25.4 - (28 - mondo) * 0.44 : 25.4 + (mondo - 28) * 0.5; }
  function terrainWeights(t) {
    var w = { park: 0, all: 0, pow: 0 };
    if (!t || !t.length) { w.all = 1; return w; }
    if (t.length === 1) { w[t[0]] = 1; return w; }
    w[t[0]] = 0.65; w[t[1]] = 0.35; return w;
  }
  /* +1 leans short and loose, -1 leans long and stable. */
  function sizeLean(r) {
    var s = 0, t = r.terrain || [];
    if (t[0] === 'park') s += 0.6; if (t[0] === 'pow') s -= 0.6;
    if (t[1] === 'park') s += 0.2; if (t[1] === 'pow') s -= 0.2;
    s += ({ feet: 0.3, playful: 0.4, surfy: -0.2, charging: -0.4 })[r.style] || 0;
    return clamp(s, -1, 1);
  }
  function hiEff(s) { return s.plus ? s.hi + 25 : s.hi; }
  function scoreSize(b, s, r, lean, iw) {
    var target = 0.5 + 0.15 * lean, hi = hiEff(s), over = 0, pos, wS;
    if (r.w < s.lo) { over = s.lo - r.w; pos = 0; wS = Math.max(-1, 0.4 - over / 20); }
    else if (r.w > hi && !s.plus) { over = r.w - hi; pos = 1; wS = Math.max(-1, 0.4 - over / 20); }
    else if (r.w > hi) { pos = 1; wS = Math.max(0.5, 1 - 0.5 * Math.abs(1 - target) - (r.w - hi) / 80); }
    else { pos = (r.w - s.lo) / ((hi - s.lo) || 1); wS = 1 - 0.5 * Math.abs(pos - target); }
    var d = s.waist - iw, widthS = 1;
    /* Too narrow drags a boot, so it costs the most. A little too wide only slows edge changes,
       but it still counts, so a regular width beats a wide when the boots clear both. */
    if (d < -0.6) widthS = 1 - (-0.6 - d) * 1.4;
    else if (b.wideByDesign) { if (d > 0.6) widthS = 1 - (d - 0.6) * 0.25; }
    else if (d > 0.6) widthS = 0.86 - (d - 0.6) * 0.6;
    else if (d > 0.2) widthS = 1 - (d - 0.2) * 0.35;
    widthS = Math.max(-1, widthS);
    var idealLen = 0.88 * r.h - 2.5 * lean - (b.wideByDesign ? 3 : 0);
    var hS = Math.max(0, 1 - Math.abs(s.len - idealLen) / 12);
    return { size: s, fit: 0.55 * wS + 0.30 * widthS + 0.15 * hS, over: over, under: r.w < s.lo, pos: pos, d: d };
  }
  function shapeScore(b, r, tw) {
    if (r.shape === 'twin') return b.shape === 'twin' ? 1 : b.shape === 'dtwin' ? 0.6 : 0.15;
    if (r.shape === 'dir') return b.shape === 'dir' ? 1 : b.shape === 'dtwin' ? 0.7 : 0.15;
    var L = tw.park - tw.pow;
    return b.shape === 'twin' ? 0.75 + 0.25 * L : b.shape === 'dir' ? 0.75 - 0.25 * L : 0.8;
  }
  /* Where the rider lands on a board's size run, for the star chart. */
  function youLen(b, r, lean) {
    var target = 0.5 + 0.15 * lean;
    var pts = b.sizes.filter(function (s) { return !s.wide; });
    if (pts.length < 2) pts = b.sizes.slice();
    pts = pts.map(function (s) { return [s.lo + (hiEff(s) - s.lo) * target, s.len]; }).sort(function (a, c) { return a[0] - c[0]; });
    var byW = pts[0][1], n = pts.length;
    if (r.w <= pts[0][0]) byW = pts[0][1] - Math.min(3, (pts[0][0] - r.w) / 8);
    else if (r.w >= pts[n - 1][0]) byW = pts[n - 1][1] + Math.min(3, (r.w - pts[n - 1][0]) / 8);
    else for (var i = 1; i < n; i++) if (r.w <= pts[i][0]) { var f = (r.w - pts[i - 1][0]) / ((pts[i][0] - pts[i - 1][0]) || 1); byW = pts[i - 1][1] + f * (pts[i][1] - pts[i - 1][1]); break; }
    var byH = 0.88 * r.h - 2.5 * lean - (b.wideByDesign ? 3 : 0);
    return 0.7 * byW + 0.3 * byH;
  }
  /* rider: { sizing: 'm' | 'w', h: cm, w: lb, mondo: cm, style, terrain: [main, second?], shape: 'twin' | 'dir' | 'auto' } */
  function rank(boards, r) {
    var tw = terrainWeights(r.terrain), lean = sizeLean(r), iw = idealWaist(r.mondo);
    var kidSized = r.h <= 150 && r.w <= 115;
    var list = boards.map(function (b) {
      var best = null;
      b.sizes.forEach(function (s) { var sc = scoreSize(b, s, r, lean, iw); if (!best || sc.fit > best.fit) best = sc; });
      var T = 0; ['park', 'all', 'pow'].forEach(function (k) { T += tw[k] * clamp((b.terr[k] - 4) / 6, 0, 1); });
      var S = shapeScore(b, r, tw), St = b.style[r.style] || 0, F = clamp(best.fit, 0, 1);
      /* What the board is (terrain, shape, style), scaled by how well a size physically fits. */
      var total = (0.41 * T + 0.24 * S + 0.35 * St) * (0.55 + 0.45 * F);
      var grow = r.style === 'feet' && !b.beginner;
      if (grow) total *= 0.82;
      var same = b.sizes.filter(function (s) { return s.wide === best.size.wide; }).sort(function (a, c) { return a.len - c.len; });
      var ix = same.indexOf(best.size);
      function covers(s) { return s && r.w >= s.lo && (s.plus || r.w <= s.hi) && (s.waist - iw) >= -0.9; }
      return {
        board: b, size: best.size, fit: best.fit, over: best.over, under: best.under, pos: best.pos, d: best.d,
        down: covers(same[ix - 1]) ? same[ix - 1] : null, up: covers(same[ix + 1]) ? same[ix + 1] : null,
        total: total, match: Math.min(99, Math.round(100 * Math.sqrt(total))), grow: grow, youLen: youLen(b, r, lean),
        eligible: best.over <= (best.under ? 5 : 10) && best.d >= -1.0 && best.d <= (b.wideByDesign ? 2.2 : 1.5) &&
          (!b.kids || kidSized) && (!r.sizing || b.cats.indexOf(r.sizing) > -1)
      };
    }).sort(function (a, c) { return c.total - a.total; });
    var pool = list.filter(function (e) { return e.eligible; }), top = pool.slice(0, 3);
    /* Women's sizing: a board marked "always show for women" makes the three when one of its sizes fits her. */
    if (r.sizing === 'w') {
      var pick = pool.filter(function (e) { return e.board.womensPick && top.indexOf(e) < 0; })[0];
      if (pick) { pick.womensPick = true; top[Math.min(top.length, 2)] = pick; }
    }
    return { rider: r, idealWaist: iw, top: top, pool: pool };
  }

  /* ------------------------------------------------------------------------
     DRAWINGS
     ------------------------------------------------------------------------ */
  /* Board outline to scale from tip / waist / tail width, length, stance and setback. Tail left, nose right. */
  function outline(b, s) {
    var k = 400 / 165, W = 440, H = 96, cy = H / 2, L = s.len * k, x0 = (W - L) / 2, x1 = x0 + L;
    var nl = L * (b.shape === 'dir' ? 0.17 : b.shape === 'dtwin' ? 0.13 : 0.12), tl = L * (b.shape === 'dir' ? 0.10 : b.shape === 'dtwin' ? 0.11 : 0.12);
    var th = s.tail * k / 2, nh = s.tip * k / 2, wh = s.waist * k / 2, xT = x0 + tl, xN = x1 - nl, cx = (xT + xN) / 2;
    var cyW = 2 * wh - (th + nh) / 2, kb = 0.86, kn = b.nose === 'point' ? 0.5 : 0.86;
    var d = 'M' + x0 + ',' + cy +
      ' C' + x0 + ',' + (cy - th * kb) + ' ' + (x0 + tl * 0.4) + ',' + (cy - th) + ' ' + xT + ',' + (cy - th) +
      ' Q' + cx + ',' + (cy - cyW) + ' ' + xN + ',' + (cy - nh) +
      ' C' + (x1 - nl * 0.4) + ',' + (cy - nh) + ' ' + x1 + ',' + (cy - nh * kn) + ' ' + x1 + ',' + cy +
      ' C' + x1 + ',' + (cy + nh * kn) + ' ' + (x1 - nl * 0.4) + ',' + (cy + nh) + ' ' + xN + ',' + (cy + nh) +
      ' Q' + cx + ',' + (cy + cyW) + ' ' + xT + ',' + (cy + th) +
      ' C' + (x0 + tl * 0.4) + ',' + (cy + th) + ' ' + x0 + ',' + (cy + th * kb) + ' ' + x0 + ',' + cy + 'Z';
    var sb = (s.sb != null ? s.sb : b.setback || 0) * 2.54 * k, ref = x0 + L / 2 - sb, st = s.stance * 2.54 * k / 2, ins = '';
    [ref - st, ref + st].forEach(function (x) {
      if (b.channel) ins += '<line class="b-chan" x1="' + (x - 16) + '" y1="' + cy + '" x2="' + (x + 16) + '" y2="' + cy + '"/>';
      else [-10, 0, 10].forEach(function (dx) { [-5, 5].forEach(function (dy) { ins += '<circle class="b-dot" cx="' + (x + dx) + '" cy="' + (cy + dy) + '" r="1.5"/>'; }); });
    });
    return { d: d, ins: ins, x0: x0, x1: x1, cy: cy, W: W, H: H };
  }
  function boardSVG(b, s) {
    var o = outline(b, s);
    return '<svg viewBox="0 0 ' + o.W + ' ' + o.H + '" role="img" aria-label="' + esc(b.name) + ' ' + esc(s.label) + ' outline, drawn to scale">' +
      '<line class="b-mid" x1="' + (o.x0 + 6) + '" y1="' + o.cy + '" x2="' + (o.x1 - 6) + '" y2="' + o.cy + '"/>' +
      '<path class="b-out" d="' + o.d + '"/>' + o.ins +
      '<text class="c-t" x="' + (o.x0 - 4) + '" y="12" text-anchor="start">TAIL</text><text class="c-t" x="' + (o.x1 + 4) + '" y="12" text-anchor="end">NOSE</text></svg>';
  }
  function miniOutline(kind) {
    var twin = { shape: 'twin', nose: 'blunt', setback: 0 }, dir = { shape: 'dir', nose: 'point', setback: 5 };
    var st = { len: 156, tip: 29.8, waist: 25.4, tail: 29.8, stance: 22 }, sd = { len: 157, tip: 30.8, waist: 25.8, tail: 28.6, stance: 22 };
    var o = kind === 'dir' ? outline(dir, sd) : outline(twin, st);
    var body = '<path class="o-line" d="' + o.d + '"/>' + o.ins.replace(/class="b-dot"/g, 'class="o-dot"');
    if (kind === 'auto') body = '<path class="o-line" stroke-dasharray="4 5" d="' + o.d + '"/><text x="220" y="58" text-anchor="middle" fill="currentColor" font-size="30">?</text>';
    return '<svg viewBox="0 0 440 96" aria-hidden="true">' + body + '</svg>';
  }
  function prng(seed) { return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  /* The size run as a constellation: x is length, y is waist width, each star a size. */
  function starChart(e, iw) {
    var b = e.board, W = 340, H = 236, pl = 38, pr = 22, pt = 22, pb = 34, i;
    var lens = b.sizes.map(function (s) { return s.len; }), ws = b.sizes.map(function (s) { return s.waist; });
    var x0 = Math.min.apply(0, lens) - 3, x1 = Math.max.apply(0, lens) + 3, y0 = Math.min.apply(0, ws) - 0.5, y1 = Math.max.apply(0, ws) + 0.5;
    function X(v) { return pl + (v - x0) / (x1 - x0) * (W - pl - pr); }
    function Y(v) { return H - pb - (v - y0) / (y1 - y0) * (H - pt - pb); }
    var seed = 7; for (i = 0; i < b.id.length; i++) seed = seed * 31 + b.id.charCodeAt(i) | 0;
    var rnd = prng(seed), g = '';
    for (i = 0; i < 46; i++) g += '<circle class="c-speck" cx="' + one(rnd() * W) + '" cy="' + one(rnd() * H) + '" r="' + one(0.3 + rnd() * 0.8) + '" opacity="' + one(0.15 + rnd() * 0.5) + '"/>';
    g += '<path class="c-axis" d="M' + pl + ',' + (pt - 6) + ' V' + (H - pb) + ' H' + (W - pr + 6) + '"/>';
    g += '<text class="c-t" x="' + pl + '" y="' + (H - 10) + '">' + Math.min.apply(0, lens) + '</text><text class="c-t" x="' + (W - pr) + '" y="' + (H - 10) + '" text-anchor="end">' + Math.max.apply(0, lens) + ' cm</text>';
    g += '<text class="c-t" x="' + ((pl + W - pr) / 2) + '" y="' + (H - 10) + '" text-anchor="middle">LENGTH</text>';
    g += '<text class="c-t" x="12" y="' + ((pt + H - pb) / 2) + '" text-anchor="middle" transform="rotate(-90 12 ' + ((pt + H - pb) / 2) + ')">WAIST WIDTH</text>';
    var sorted = b.sizes.slice().sort(function (a, c) { return a.len - c.len || a.waist - c.waist; });
    g += '<polyline class="c-link" points="' + sorted.map(function (s) { return one(X(s.len)) + ',' + one(Y(s.waist)); }).join(' ') + '"/>';
    var ux = clamp(X(e.youLen), pl + 4, W - pr - 4), uy = clamp(Y(iw), pt + 4, H - pb - 4);
    g += '<path class="c-you" d="M' + one(ux) + ',' + (pt - 4) + ' V' + (H - pb) + ' M' + pl + ',' + one(uy) + ' H' + (W - pr + 4) + '"/>';
    g += '<text class="c-ty" x="' + one(ux + (ux > W - 70 ? -6 : 6)) + '" y="' + (pt + 4) + '" text-anchor="' + (ux > W - 70 ? 'end' : 'start') + '">YOU</text>';
    sorted.forEach(function (s) {
      var x = X(s.len), y = Y(s.waist);
      if (s === e.size) {
        var left = x > pl + 46;
        g += '<circle class="c-ring" cx="' + one(x) + '" cy="' + one(y) + '" r="11"/>';
        g += '<path class="c-mine" d="M' + one(x) + ',' + one(y - 8) + ' L' + one(x + 2) + ',' + one(y - 2) + ' L' + one(x + 8) + ',' + one(y) + ' L' + one(x + 2) + ',' + one(y + 2) + ' L' + one(x) + ',' + one(y + 8) + ' L' + one(x - 2) + ',' + one(y + 2) + ' L' + one(x - 8) + ',' + one(y) + ' L' + one(x - 2) + ',' + one(y - 2) + 'Z"/>';
        g += '<text class="c-tm" x="' + one(x + (left ? -15 : 15)) + '" y="' + one(y + 4) + '" text-anchor="' + (left ? 'end' : 'start') + '">' + esc(s.label) + '</text>';
      } else {
        g += '<circle class="c-star" cx="' + one(x) + '" cy="' + one(y) + '" r="2.4"/>';
        g += '<text class="c-t" x="' + one(x) + '" y="' + one(s.wide ? y - 7 : y + 14) + '" text-anchor="middle">' + esc(s.label) + '</text>';
      }
    });
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="Size chart for the ' + esc(b.name) + ' as a constellation. Your size, ' + esc(e.size.label) + ', is the brightest star.">' + g + '</svg>';
  }

  /* ------------------------------------------------------------------------
     ONE FINDER ON THE PAGE
     ------------------------------------------------------------------------ */
  var STYLE = { feet: 'Finding my feet', playful: 'Playful', surfy: 'Surfy', charging: 'Hard charging' };
  var TERR = { park: 'Park', all: 'All mountain', pow: 'Powder' };
  var SHAPE = { twin: 'True twin', dtwin: 'Directional twin', dir: 'Directional' };
  var SHAPE_SAY = {
    twin: 'Matching nose and tail, stance centered. Rides the same switch.',
    dtwin: 'Twin outline with the stance set slightly back. Freestyle feel, more drive.',
    dir: 'Longer nose, stance set back. Floats in powder and tracks through a carve.'
  };
  var TRANSIT = {
    feet: 'Your sign is rising. Progress comes fast this season. Take the lesson, then take the next lift too.',
    playful: 'Your chart leans playful. Expect butters, side hits and at least one trick named after a friend.',
    surfy: 'Your chart leans surf. Follow the fall line and let the turn finish itself.',
    charging: 'Your chart leans fast. The mountain opens up for you this season. Tighten your bindings.'
  };

  function mount(root) {
    if (root.__sbf) return;
    root.__sbf = true;
    function $(s, r) { return (r || root).querySelector(s); }
    function $$(s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); }
    function el(name) { return $('[data-el="' + name + '"]'); }

    var data = {}, boards = [];
    try { data = JSON.parse($('[data-sbf-data]').textContent) || {}; } catch (e) { data = {}; }
    (data.boards || []).forEach(function (d) { var b = buildBoard(d); if (b) boards.push(b); });

    var KEY = 'sbf.answers.v2';
    var state = { step: 1, view: 'form', style: null, sizing: null, units: 'imperial', ft: '', inch: '', cm: '', weight: '', bootSystem: 'usm', boot: '', terrain: [], shape: null };
    var res = null, lastWild = null, wildTimer = null, started = false;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add', cartUrl = root.getAttribute('data-cart-url') || '/cart';

    function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
    function load() { try { var s = JSON.parse(localStorage.getItem(KEY) || 'null'); if (s && typeof s === 'object') return s; } catch (e) {} return null; }
    function wipe() { try { localStorage.removeItem(KEY); } catch (e) {} }
    /* For analytics: a DOM event anything can listen for, plus Shopify's pixel bus when it is there. */
    function track(name, detail) {
      try {
        document.dispatchEvent(new CustomEvent('boardfinder:' + name, { detail: detail || {} }));
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('board_finder_' + name, detail || {});
      } catch (e) {}
    }

    /* ---------- form ---------- */
    function fillSelect(sel, opts, placeholder, value) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>' + opts.map(function (o) { return '<option value="' + o[0] + '">' + o[1] + '</option>'; }).join('');
      sel.value = value == null ? '' : String(value);
    }
    function bootOptions(sys) {
      var out = [], a, b, v;
      if (sys === 'usm') { a = 1; b = 15; } else if (sys === 'usw') { a = 4; b = 12; } else { a = 33; b = 50; }
      for (v = a; v <= b; v += 0.5) out.push([v, String(v)]);
      return out;
    }
    function range(a, b, suffix) { var o = []; for (var i = a; i <= b; i++) o.push([i, i + suffix]); return o; }

    function syncForm() {
      $$('input[data-group]').forEach(function (i) {
        var g = i.getAttribute('data-group');
        i.checked = g === 'terrain' ? state.terrain.indexOf(i.value) > -1 : state[g] === i.value;
        i.parentNode.classList.toggle('is-on', i.checked);
        if (g === 'terrain') {
          var ord = $('.sbf-ord', i.parentNode), ix = state.terrain.indexOf(i.value);
          ord.hidden = ix < 0; ord.textContent = ix === 0 ? 'Main' : ix === 1 ? 'Second' : '';
        }
      });
      $$('[data-sizing]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-sizing') === state.sizing)); });
      $$('[data-units]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-units') === state.units)); });
      var imp = state.units === 'imperial';
      el('h-imp').hidden = !imp; el('h-met').hidden = imp;
      el('w-unit').textContent = imp ? 'lb' : 'kg';
      el('weight').placeholder = imp ? '170' : '77';
      el('ft').value = state.ft; el('in').value = state.inch; el('cm').value = state.cm; el('weight').value = state.weight;
      el('bootsys').value = state.bootSystem;
      fillSelect(el('boot'), bootOptions(state.bootSystem), 'Size', state.boot);
    }
    function rider() {
      var h, w, boot = parseFloat(state.boot);
      if (state.sizing !== 'm' && state.sizing !== 'w') return { error: 'Pick men’s or women’s sizing.' };
      if (state.units === 'imperial') {
        if (state.ft === '' || state.inch === '') return { error: 'Add your height.' };
        h = (parseInt(state.ft, 10) * 12 + parseInt(state.inch, 10)) * 2.54;
        w = parseFloat(state.weight);
      } else {
        h = parseFloat(state.cm);
        w = parseFloat(state.weight) * 2.20462;
      }
      if (!h || isNaN(h)) return { error: 'Add your height.' };
      if (h < 100 || h > 215) return { error: state.units === 'imperial' ? 'Height should be between 3′4″ and 7′0″.' : 'Height should be between 100 and 215 cm.' };
      if (!w || isNaN(w)) return { error: 'Add your weight.' };
      if (w < 40 || w > 300) return { error: state.units === 'imperial' ? 'Weight should be between 40 and 300 lb.' : 'Weight should be between 18 and 136 kg.' };
      if (isNaN(boot)) return { error: 'Pick your boot size.' };
      return { sizing: state.sizing, h: h, w: w, mondo: bootToMondo(state.bootSystem, boot), style: state.style, terrain: state.terrain.slice(), shape: state.shape };
    }
    function stepOk(n) {
      if (n === 1) return !!state.style;
      if (n === 2) return !rider().error;
      if (n === 3) return state.terrain.length > 0;
      return !!state.shape;
    }
    function paint(focus) {
      var inForm = state.view === 'form';
      el('form').hidden = !inForm; el('results').hidden = inForm;
      $$('[data-step]').forEach(function (s) { s.hidden = Number(s.getAttribute('data-step')) !== state.step; });
      $$('.sbf-meter i').forEach(function (b, i) { b.classList.toggle('on', !inForm || i < state.step); });
      el('steplabel').textContent = inForm ? 'Step ' + state.step + ' of 4' : 'Signal locked';
      var nx = $('[data-step="' + state.step + '"] [data-next]');
      if (nx) nx.disabled = state.step !== 2 && !stepOk(state.step);
      if (focus) {
        var h = inForm ? $('[data-step="' + state.step + '"] h2') : el('rtitle');
        if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
        try { root.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' }); } catch (e) {}
      }
    }
    function next() {
      if (state.step === 2) {
        var r = rider();
        el('err').textContent = r.error || '';
        if (r.error) return;
      } else if (!stepOk(state.step)) return;
      if (state.step < 4) { state.step++; save(); paint(true); }
      else showResults(true, true);
    }

    /* ---------- formatting ---------- */
    function fmtW(lb) { return state.units === 'imperial' ? Math.round(lb) + ' lb' : Math.round(lb / 2.20462) + ' kg'; }
    function fmtRange(s) {
      var m = state.units === 'imperial' ? 1 : 1 / 2.20462;
      return Math.round(s.lo * m) + '–' + Math.round(s.hi * m) + (s.plus ? '+' : '') + (state.units === 'imperial' ? ' lb' : ' kg');
    }
    function fmtH() { return state.units === 'imperial' ? state.ft + '′' + state.inch + '″' : Math.round(parseFloat(state.cm)) + ' cm'; }
    function bootLabel() { return ({ usm: 'US Men’s ', usw: 'US Women’s ', eu: 'EU ' })[state.bootSystem] + state.boot; }
    function productUrl(e) { return e.board.url + (e.size.variantId ? (e.board.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + e.size.variantId : ''); }

    /* ---------- results ---------- */
    function sizeLine(e) {
      var s = e.size, w = fmtW(res.rider.w), t;
      if (e.over > 0 && e.under) t = 'At ' + w + ' you are just under the listed range for the ' + s.label + ' (' + fmtRange(s) + '). It will feel a touch stiff and long.';
      else if (e.over > 0) t = 'At ' + w + ' you are just over the listed range for the ' + s.label + ' (' + fmtRange(s) + '). It will ride softer than intended.';
      else t = w + ' sits ' + (e.pos < 0.34 ? 'at the light end of' : e.pos > 0.66 ? 'at the heavy end of' : 'mid-range on') + ' the ' + s.label + ' (' + fmtRange(s) + ').';
      if (e.down) t += ' Size down to the ' + e.down.label + ' for a looser, quicker feel.';
      if (e.up) t += ' Size up to the ' + e.up.label + ' for more stability and float.';
      return t;
    }
    function widthLine(e) {
      var s = e.size, t = 'Your ' + bootLabel() + ' boots want a waist near ' + one(res.idealWaist) + ' cm. The ' + s.label + ' measures ' + one(s.waist) + '.';
      if (e.d < -0.6) t += ' A touch narrow, so run a little more binding angle.';
      else if (s.wide) t += res.idealWaist >= 25.6 ? ' That is why you are on the wide.' : ' The wide is where your weight sits best in this run.';
      else if (e.d > 0.6 && e.board.wideByDesign) t += ' Wider on purpose. That is where the float comes from.';
      else if (e.d > 0.6) t += ' A little wide for your boots, so edge changes take more effort.';
      return t;
    }
    function detailHTML(e, kind, rankIx) {
      var b = e.board, s = e.size, mine = res.rider.terrain, i;
      var eyebrow = kind === 'wild' ? 'Wildcard // The mountain chose' : e.womensPick ? 'Women’s pick' : ['Best match', 'Strong match', 'Also aligned'][rankIx];
      var terr = ['park', 'all', 'pow'].map(function (k) {
        return '<div class="' + (mine.indexOf(k) > -1 ? 'mine' : '') + '"><span>' + TERR[k] + '</span><u><i style="width:' + b.terr[k] * 10 + '%"></i></u><span>' + b.terr[k] + '</span></div>';
      }).join('');
      var flex = ''; for (i = 1; i <= 10; i++) flex += '<i class="' + (i <= b.flex ? 'on' : '') + '"></i>';
      var price = s.price || b.price || '', sold = s.variantId && !s.available;
      var omens = [['Power move', b.move], ['Lucky conditions', b.lucky], ['Watch for', b.watch]].filter(function (o) { return o[1]; })
        .map(function (o) { return '<div><span class="sbf-tc">' + o[0] + '</span><span>' + esc(o[1]) + '</span></div>'; }).join('');
      var cta = s.variantId
        ? '<button type="button" class="sbf-btn sbf-tc" data-add' + (sold ? ' disabled' : '') + '>' + (sold ? 'Size ' + esc(s.label) + ' is sold out' : 'Add the ' + esc(s.label) + ' to cart' + (price ? ' — ' + esc(price) : '')) + '</button>' +
          '<a class="sbf-link sbf-tc" data-view href="' + esc(productUrl(e)) + '">View the ' + esc(b.name) + '</a>'
        : '<a class="sbf-btn sbf-tc" data-view href="' + esc(productUrl(e)) + '">Shop the ' + esc(b.name) + (price ? ' — ' + esc(price) : '') + '</a>';
      return '<article class="sbf-reading">' +
        '<div class="sbf-rhead"><span class="sbf-tc">' + eyebrow + ' // Sign: ' + esc(b.sign) + '</span>' +
        '<h3 class="sbf-rname sbf-hd" tabindex="-1" data-el="dname">' + esc(b.name) + '</h3>' +
        '<p class="sbf-sub">' + esc(b.sign) + ' · ' + b.who + ' · ' + SHAPE[b.shape] + ' · ' + esc(b.profile) + '</p></div>' +
        (b.image ? '<a class="sbf-photo" data-view href="' + esc(productUrl(e)) + '"><img src="' + esc(b.image) + '" alt="' + esc(b.name + ' ' + b.sign) + ' snowboard" width="1280" height="1725" loading="lazy"></a>' : '') +
        '<div class="sbf-stats"><div><span class="sbf-tc">Match</span><span class="sbf-stat sbf-hd">' + e.match + '%</span></div><div><span class="sbf-tc">Size</span><span class="sbf-stat sbf-hd">' + esc(s.label) + '</span></div><div><span class="sbf-tc">Price</span><span class="sbf-stat sbf-hd">' + esc(price) + '</span></div></div>' +
        '<div class="sbf-rbody"><div class="sbf-chart">' + starChart(e, res.idealWaist) + boardSVG(b, s) +
        '<p class="sbf-cap">Each star is a size in the ' + esc(b.name) + ' run. The bright one is yours. Outline drawn to scale: ' + s.len + ' cm long, ' + one(s.waist) + ' cm at the waist' + (s.sb ? ', stance set back ' + s.sb + ' in' : ', stance centered') + '.</p></div>' +
        '<div class="sbf-text">' + (b.vibe ? '<p class="sbf-vibe sbf-hd">' + esc(b.vibe) + '</p>' : '') +
        (b.reading ? '<p class="sbf-read">' + esc(b.reading) + '</p>' : '') + '<p class="sbf-read">' + TRANSIT[res.rider.style] + '</p>' +
        (omens ? '<div class="sbf-omens">' + omens + '</div>' : '') +
        '<div class="sbf-cta">' + cta + '<span class="sbf-cta__msg" data-el="ctamsg" role="status"></span></div></div></div></article>' +
        '<div class="sbf-fit" style="margin-top:22px"><h3 class="sbf-sect sbf-hd">Why it fits</h3><div class="sbf-rows">' +
        '<div class="sbf-rowx"><span class="sbf-tc">Length // set by weight</span><span class="sbf-big sbf-hd">' + esc(s.label) + '</span><p>' + esc(sizeLine(e)) + '</p></div>' +
        '<div class="sbf-rowx"><span class="sbf-tc">Width // set by boots</span><span class="sbf-big sbf-hd">' + one(s.waist) + ' cm' + (s.wide ? ' wide' : '') + '</span><p>' + esc(widthLine(e)) + '</p></div>' +
        '<div class="sbf-rowx"><span class="sbf-tc">Flex // ' + b.flex + ' of 10</span><div class="sbf-flex" role="img" aria-label="Flex ' + b.flex + ' out of 10">' + flex + '</div><p>' + flexSay(b.flex) + (e.grow ? ' <span class="sbf-note">Rated intermediate and up. A board to grow into, not to learn on.</span>' : '') + '</p></div>' +
        '<div class="sbf-rowx"><span class="sbf-tc">Terrain // Signal’s ratings</span><div class="sbf-terr">' + terr + '</div></div>' +
        '<div class="sbf-rowx"><span class="sbf-tc">Shape</span><span class="sbf-big sbf-hd">' + SHAPE[b.shape] + '</span><p>' + SHAPE_SAY[b.shape] + '</p></div>' +
        '<div class="sbf-rowx"><span class="sbf-tc">Profile</span><span class="sbf-big sbf-hd">' + esc(b.profile) + '</span><p>' + b.profileSay + '</p></div>' +
        '</div><p class="sbf-src">Flex, terrain ratings, sizes and rider weight ranges come from each board’s spec sheet.</p></div>';
    }
    var shown = null;
    function select(key, focus) {
      var e = key === 'wild' ? lastWild : res.top[key];
      if (!e) return;
      shown = e;
      $$('.sbf-pick').forEach(function (p) { var on = p.getAttribute('data-k') === String(key); p.classList.toggle('is-on', on); p.setAttribute('aria-pressed', String(on)); });
      el('detail').innerHTML = detailHTML(e, key === 'wild' ? 'wild' : 'match', key);
      if (focus) { var h = el('dname'); try { h.focus({ preventScroll: true }); } catch (x) { h.focus(); } }
    }
    function wildPool() {
      var c = res.pool.filter(function (e) { return e !== lastWild && (e.board.style[res.rider.style] || 0) >= 0.3; });
      /* Skip the best match when there is anything else to draw. */
      return c.length > 1 ? c.filter(function (e) { return e !== res.top[0]; }) : c;
    }
    function drawWild() {
      var tile = $('.sbf-pick.wild'), pool = wildPool();
      if (!pool.length && lastWild) { lastWild = null; pool = wildPool(); }
      if (!pool.length || wildTimer) return;
      var sum = 0, roll, pick = pool[0], i;
      pool.forEach(function (e) { sum += e.total * e.total; });
      roll = Math.random() * sum;
      for (i = 0; i < pool.length; i++) { roll -= pool[i].total * pool[i].total; if (roll <= 0) { pick = pool[i]; break; } }
      function land() {
        wildTimer = null; lastWild = pick;
        $('.sbf-pick__n', tile).textContent = pick.board.name; $('.sbf-pick__m', tile).textContent = pick.match + '% · ' + pick.size.label + ' · Draw again';
        select('wild', true);
        track('wildcard', { board: pick.board.handle, size: pick.size.label });
      }
      if (reduce) return land();
      var n = 0, names = boards.map(function (b) { return b.name; });
      wildTimer = setInterval(function () {
        $('.sbf-pick__n', tile).textContent = names[(n * 5 + 2) % names.length]; n++;
        if (n > 9) { clearInterval(wildTimer); land(); }
      }, 85);
    }
    function showResults(focus, fresh) {
      var r = rider();
      if (r.error) { state.step = 2; state.view = 'form'; paint(focus); el('err').textContent = r.error; return; }
      res = rank(boards, r); lastWild = null; state.view = 'results'; save();
      var t = r.terrain.map(function (k) { return TERR[k]; }).join(' + ');
      el('chips').innerHTML = [STYLE[r.style], r.sizing === 'w' ? 'Women’s sizing' : 'Men’s sizing', fmtH(), fmtW(r.w), 'Boot ' + bootLabel(), t, state.shape === 'auto' ? 'Shape: open' : state.shape === 'twin' ? 'Twin' : 'Directional']
        .map(function (c) { return '<span>' + esc(c) + '</span>'; }).join('');
      var picks = el('picks'), det = el('detail');
      if (!res.top.length) {
        el('rtitle').textContent = 'Outside our size run.';
        picks.innerHTML = '';
        det.innerHTML = '<div class="sbf-why"><span class="sbf-tc">What to do</span><p><strong>No board in the line lists your weight and boot size together.</strong> Send us your numbers and we will size you by hand.</p></div>';
        if (fresh) track('completed', { style: r.style, sizing: r.sizing, terrain: r.terrain.join(','), shape: r.shape, boards: '' });
        paint(focus); return;
      }
      el('rtitle').textContent = 'The chart is in.';
      var labs = ['01 // Best match', '02 // Strong match', '03 // Also aligned'];
      picks.innerHTML = res.top.map(function (e, i) {
        return '<button type="button" class="sbf-pick" data-k="' + i + '" aria-pressed="false"><span class="sbf-tc">' + (e.womensPick ? '0' + (i + 1) + ' // Women’s pick' : labs[i]) + '</span><span class="sbf-pick__n sbf-hd">' + esc(e.board.name) + '</span><span class="sbf-pick__m">' + e.match + '% · ' + esc(e.size.label) + '</span></button>';
      }).join('') + (wildPool().length ? '<button type="button" class="sbf-pick wild" data-k="wild" aria-pressed="false"><span class="sbf-tc">Wildcard</span><span class="sbf-pick__n sbf-hd">Let the mountain pick</span><span class="sbf-pick__m">Draw a board that fits you</span></button>' : '');
      select(0, false);
      if (fresh) track('completed', { style: r.style, sizing: r.sizing, terrain: r.terrain.join(','), shape: r.shape, boards: res.top.map(function (e) { return e.board.handle + ':' + e.size.label; }).join(',') });
      paint(focus);
    }

    /* ---------- cart ---------- */
    function addToCart(btn) {
      var e = shown, msg = el('ctamsg');
      if (!e || !e.size.variantId) return;
      var label = btn.textContent, drawer = document.getElementById('Cart-Drawer');
      var body = { items: [{ id: e.size.variantId, quantity: 1 }] };
      /* Ask for the same cart sections the theme's own product form re-renders. */
      if (drawer) { body.sections = 'cart-drawer,cart-bubble'; body.sections_url = window.location.pathname; }
      btn.disabled = true; btn.textContent = 'Adding…'; msg.textContent = '';
      fetch(cartAddUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (out) {
          if (!out.ok || out.j.status) throw new Error(out.j.description || out.j.message || 'That size could not be added.');
          track('add_to_cart', { board: e.board.handle, size: e.size.label, variant: e.size.variantId });
          var sections = out.j.sections, opened = false;
          if (drawer && sections && typeof OverlayManager !== 'undefined') {
            [['Cart-Drawer', 'cart-drawer', '.cart-drawer'], ['cart-drawer-toggle', 'cart-bubble', '.thb-item-count']].forEach(function (s) {
              var host = document.getElementById(s[0]), html = sections[s[1]];
              if (!host || !html) return;
              var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(s[2]);
              if (fresh) (host.querySelector(s[2]) || host).innerHTML = fresh.innerHTML;
            });
            try { OverlayManager.open(drawer); document.dispatchEvent(new CustomEvent('cart-drawer:open', { detail: {} })); opened = true; } catch (x) {}
          }
          if (!opened) { window.location.href = cartUrl; return; }
          btn.disabled = false; btn.textContent = label; msg.textContent = 'Added. The ' + e.size.label + ' is in your cart.';
        })
        .catch(function (err) {
          btn.disabled = false; btn.textContent = label;
          msg.textContent = (err && err.message ? err.message : 'That size could not be added.') + ' Open the board page to finish.';
        });
    }

    /* ---------- events ---------- */
    root.addEventListener('change', function (ev) {
      var t = ev.target, g = t.getAttribute('data-group'), name = t.getAttribute('data-el');
      if (g === 'style' || g === 'shape') state[g] = t.value;
      else if (g === 'terrain') {
        var ix = state.terrain.indexOf(t.value);
        if (ix > -1) state.terrain.splice(ix, 1);
        else { if (state.terrain.length === 2) state.terrain.pop(); state.terrain.push(t.value); }
      }
      else if (name === 'ft') state.ft = t.value;
      else if (name === 'in') state.inch = t.value;
      else if (name === 'bootsys') { state.bootSystem = t.value; state.boot = ''; }
      else if (name === 'boot') state.boot = t.value;
      else return;
      if (!started) { started = true; track('started', {}); }
      el('err').textContent = '';
      syncForm(); save(); paint(false);
    });
    root.addEventListener('input', function (ev) {
      var name = ev.target.getAttribute('data-el');
      if (name === 'cm') state.cm = ev.target.value; else if (name === 'weight') state.weight = ev.target.value; else return;
      el('err').textContent = ''; save();
    });
    root.addEventListener('click', function (ev) {
      var a = ev.target.closest('a[data-view]');
      if (a && shown) { track('product_click', { board: shown.board.handle, size: shown.size.label }); return; }
      var t = ev.target.closest('button');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-next')) return next();
      if (t.hasAttribute('data-back')) { state.step = Math.max(1, state.step - 1); save(); return paint(true); }
      if (t.hasAttribute('data-add')) return addToCart(t);
      if (t.hasAttribute('data-sizing')) {
        state.sizing = t.getAttribute('data-sizing');
        if (state.boot === '') state.bootSystem = state.sizing === 'w' ? 'usw' : 'usm';
        el('err').textContent = ''; syncForm(); save(); return;
      }
      if (t.hasAttribute('data-units') && t.getAttribute('data-units') !== state.units) {
        var w = parseFloat(state.weight);
        if (t.getAttribute('data-units') === 'metric') {
          if (state.ft !== '' && state.inch !== '') state.cm = String(Math.round((parseInt(state.ft, 10) * 12 + parseInt(state.inch, 10)) * 2.54));
          if (w) state.weight = String(Math.round(w / 2.20462));
        } else {
          var c = parseFloat(state.cm);
          if (c) { var tot = Math.round(c / 2.54); state.ft = String(clamp(Math.floor(tot / 12), 3, 7)); state.inch = String(tot % 12); }
          if (w) state.weight = String(Math.round(w * 2.20462));
        }
        state.units = t.getAttribute('data-units'); el('err').textContent = ''; syncForm(); save(); return;
      }
      if (t.classList.contains('sbf-pick')) return t.getAttribute('data-k') === 'wild' ? drawWild() : select(Number(t.getAttribute('data-k')), true);
      if (t.hasAttribute('data-edit')) { state.view = 'form'; state.step = 1; save(); return paint(true); }
      if (t.hasAttribute('data-reset')) {
        state = { step: 1, view: 'form', style: null, sizing: null, units: state.units, ft: '', inch: '', cm: '', weight: '', bootSystem: state.bootSystem, boot: '', terrain: [], shape: null };
        wipe(); syncForm(); return paint(true);
      }
    });
    el('form').addEventListener('submit', function (ev) { ev.preventDefault(); next(); });
    el('form').addEventListener('keydown', function (ev) { if (ev.key === 'Enter' && ev.target.tagName === 'INPUT' && ev.target.type === 'number') { ev.preventDefault(); next(); } });

    /* ---------- start ---------- */
    if (!boards.length) {
      el('form').hidden = true; el('results').hidden = true; el('empty').hidden = false;
      return;
    }
    var saved = load();
    if (saved) Object.keys(state).forEach(function (k) { if (saved[k] != null) state[k] = saved[k]; });
    if (!Array.isArray(state.terrain)) state.terrain = [];
    fillSelect(el('ft'), range(3, 7, ' ft'), 'ft', state.ft);
    fillSelect(el('in'), range(0, 11, ' in'), 'in', state.inch);
    $$('[data-outline]').forEach(function (n) { n.outerHTML = miniOutline(n.getAttribute('data-outline')); });
    syncForm();
    var pre = readPrefill();
    if (pre) {
      /* Deep link (homepage teaser, collection card, email, QR code): take the answers it carries, then open
         on the first question still unanswered, or straight on the results if nothing is missing. */
      if (pre.style) state.style = pre.style;
      if (pre.terrain) state.terrain = pre.terrain;
      if (pre.sizing) state.sizing = pre.sizing;
      started = true; track('started', { source: pre.source });
      try {
        var u = new URL(window.location.href);
        ['style', 'terrain', 'sizing', 'from'].forEach(function (k) { u.searchParams.delete(k); });
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (e) {}
      syncForm();
      var gap = [1, 2, 3, 4].filter(function (n) { return !stepOk(n); })[0];
      if (!gap) return showResults(false, true);
      state.view = 'form'; state.step = gap; save(); paint(false);
      return;
    }
    if (state.view === 'results' && stepOk(1) && stepOk(2) && stepOk(3) && stepOk(4)) showResults(false, false);
    else { state.view = 'form'; state.step = clamp(state.step | 0 || 1, 1, 4); paint(false); }
  }

  /* ?style=playful&terrain=pow,park&sizing=w&from=homepage — unknown values are ignored. */
  function readPrefill() {
    var q, out = {}, v;
    try { q = new URLSearchParams(window.location.search); } catch (e) { return null; }
    v = q.get('style'); if (/^(feet|playful|surfy|charging)$/.test(v || '')) out.style = v;
    v = (q.get('terrain') || '').split(',').filter(function (x, i, a) { return /^(park|all|pow)$/.test(x) && a.indexOf(x) === i; }).slice(0, 2);
    if (v.length) out.terrain = v;
    v = q.get('sizing'); if (v === 'm' || v === 'w') out.sizing = v;
    if (!out.style && !out.terrain && !out.sizing) return null;
    out.source = (q.get('from') || 'link').replace(/[^\w-]/g, '').slice(0, 40) || 'link';
    return out;
  }

  function mountAll(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-board-finder]'), mount); }
  window.SignalBoardFinder = { mountAll: mountAll, parseSpec: parseSpec, buildBoard: buildBoard, rank: rank, bootToMondo: bootToMondo };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mountAll(); });
  else mountAll();
  /* Theme editor: re-run when the section is added or its settings change. */
  document.addEventListener('shopify:section:load', function (ev) { mountAll(ev.target); });
})();
